module.exports = __webpack_public_path__ + "img/remind_payment.49bd54d8.svg";